import { render, staticRenderFns } from "./PageHeaderSearchRecord.vue?vue&type=template&id=3573498c&scoped=true&"
import script from "./PageHeaderSearchRecord.vue?vue&type=script&lang=js&"
export * from "./PageHeaderSearchRecord.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderSearchRecord.vue?vue&type=style&index=0&id=3573498c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573498c",
  null
  
)

export default component.exports